{
  "cards": [
    {
      "title": "MultiSport Plus",
      "text": "Is the only card on the market that allows for multiple use of sports facilities on one day/",
      "image": {
        "url": "/images/cards/card_1.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Classic",
      "text": "Take advantage of thousands of sports facilities across Poland.",
      "image": {
        "url": "/images/cards/card_2.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Light",
      "text": "Awake the passion for sports in you by training 6 to 8 times a month.",
      "image": {
        "url": "/images/cards/card_3.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    }
  ],
  "cards2": [
    {
      "title": "MultiSport Student",
      "text": "Created for people aged between 15 and 26.",
      "image": {
        "url": "/images/cards/card_6.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Senior",
      "text": "Take care of the activity of your loved ones who are over 60.",
      "image": {
        "url": "/images/cards/card_5.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Kids",
      "text": "Access to thousands of facilities for the youngest ones, even several times a day.",
      "image": {
        "url": "/images/cards/card_4.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    },
    {
      "title": "MultiSport Kids Aqua",
      "text": "For children up to 15 years of age who love water sports.",
      "image": {
        "url": "/images/cards/card_7.png",
        "alternative": "",
        "width": "446",
        "height": "282"
      }
    }
  ]
}